<script lang="ts" setup>
import { TaskModel, TaskQueueModel } from "@/components/tasks-kanban/models";
import { ListItemModel } from "../../../models";
import { PropType } from "vue";
import { TaskCardItemWrapper } from "./";
import { TirPmPopover, PopoverPositionEnum, PopoverColorEnum } from "tir-components";
import { useRouter } from "vue-router";
import { ListBulletIcon } from "tir-style-system/icons/outline";

/**Маршруты */
const router = useRouter();

/**Параметры */
const props = defineProps({
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
});

/**Перейти в очередь */
const goToQueue = (queue: TaskQueueModel) => {
  const projectId = Number(router.currentRoute.value.params.projectId);
  if (!queue.NamespaceId) {
    console.log("Нет id рабочей области");
  }
  const route = router.resolve({
    name: "queue",
    params: {
      projectId: projectId,
      namespaceId: queue.NamespaceId,
      queueId: queue.Id,
    },
  })?.href;

  window.open(route, "_target");
};
</script>
<template>
  <TaskCardItemWrapper :element="element">
    <TirPmPopover
      v-if="task.Queues?.length"
      is-tooltip
      is-no-teleport
      :color="PopoverColorEnum.Black"
      :position="PopoverPositionEnum.Top"
      :is-hide-triangle="false"
      width="15rem"
      class="task-card-queue"
    >
      <template #default>
        <ListBulletIcon class="task-card-queue_icon" />
      </template>
      <template #content>
        <div class="task-card-queue_list">
          <span
            v-for="queue in task.Queues"
            v-text="queue.Name"
            class="task-card-queue_list_item"
            @click.stop="goToQueue(queue)"
          />
        </div>
      </template>
    </TirPmPopover>
  </TaskCardItemWrapper>
</template>
<style lang="scss">
.task-card-queue {
  font-size: 0.75rem;
  &_icon {
    width: 1rem;
    height: 1rem;
    color: var(--text-secondary);
    transition: 0.2s linear;
    &:hover {
      color: #2a77ef;
    }
  }

  &_list {
    display: flex;
    flex-direction: column;
    padding: 0 0.75rem;
    &_item {
      display: inline-block;
      max-width: 100%;
      padding: 0.5rem 0;
      overflow: hidden;
      text-overflow: ellipsis;
      transition: 0.2s linear;
      &:hover {
        color: #2a77ef;
      }
    }
  }
}
</style>
